const defaultGenerator = componentName => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
export default ClassNameGenerator;


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
// module id = 1577
// module chunks = 22